import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { AppsStore } from '../stores/appsStore';


export const useAppsStore = () =>
  useContext<{
    appsStore: AppsStore;
  }>(StoreContext);
